(() => {
  const key = '__chicLazyShopFollow';
  const selector = '[data-chic-shop-follow]';
  if (window[key]) {
    window[key].scan(document);
    return;
  }
  const watched = new WeakSet();
  const observer = typeof window.IntersectionObserver === 'function' ? new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) mount(entry.target); });
  }, { rootMargin: '600px 0px' }) : null;
  function mount(slot) {
    const template = slot.querySelector('template[data-chic-shop-follow-template]');
    if (!template || slot.dataset.chicShopFollow === 'mounted') return;
    slot.dataset.chicShopFollow = 'mounted';
    if (observer) observer.unobserve(slot);
    const fragment = template.content.cloneNode(true);
    const scripts = Array.from(fragment.querySelectorAll('script'));
    scripts.forEach(script => script.remove());
    template.remove();
    slot.appendChild(fragment);
    scripts.forEach(original => {
      const script = document.createElement('script');
      for (const attribute of original.attributes) script.setAttribute(attribute.name, attribute.value);
      script.async = original.hasAttribute('async');
      if (original.nonce) script.nonce = original.nonce;
      script.textContent = original.textContent;
      slot.appendChild(script);
    });
  }
  function prepare(slot) {
    if (watched.has(slot)) return;
    watched.add(slot);
    slot.style.minHeight = '40px';
    slot.addEventListener('focusin', () => mount(slot), { once: true });
    slot.addEventListener('pointerenter', () => mount(slot), { once: true });
    if (observer) observer.observe(slot);
    else mount(slot);
  }
  function slots(root) {
    return [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
  }
  function scan(root) { slots(root).forEach(prepare); }
  window[key] = { scan };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (observer) slots(event.target).forEach(slot => observer.unobserve(slot));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
})();
